import React, { Component, Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { image_url } from '../../../config/Api';
import { getRelatedNews, getNewsDetails } from '../../actions/Publication';
import Timestamp from 'react-timestamp';
import Htmlcontent from '../Htmlcontent';




class TagNews extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: [],
      newsid: '',
      catid: '',
      content_loading: true,
      api_request: 0,
      prevSlug: '',
      currentSlug: '',
      slug:''
    }



  }

  componentDidMount = () => {
    const newsid = this.props.newsid;
    const tags = this.props.tags;
    const catid = this.props.catid;
    if (tags.length) {
      const tagid = tags.map((row, key) => {
        return row.id
      })

      var requestData = {
        newsid: newsid,
        tags: tagid
      }
      const req = this.props.getRelatedNews(requestData).then((data) => {
        this.setState({
          catid: catid,
          newsid: newsid,
          content: data
        })
      });
    }


  }


  shouldComponentUpdate(nextProps, nextState) {
  

    if(nextState.slug != nextProps.currentSlug) {
      this.setState({
        slug:nextProps.currentSlug
      })
    }
    return true;
  } 

  componentDidUpdate = (prevProps) => {
    const { currentSlug, prevSlug } = this.props;
    const { slug } = this.state;
    // console.log('componentDidUpdate this.props', this.props); 

    if (slug != currentSlug) {
      const newsid = this.props.newsid;
      const tags = this.props.tags;
      const catid = this.props.catid;
      if (tags.length) {
        const tagid = tags.map((row, key) => {
          return row.id
        })

        var requestData = {
          newsid: newsid,
          tags: tagid
        }
        const req = this.props.getRelatedNews(requestData).then((data) => {
          this.setState({
            catid: catid,
            newsid: newsid,
            content: data,
            api_request: 1,
            content_loading:false
          })
        });
      }
    }
  }

  static getDerivedStateFromProps(props, state) {

    // if (props.details.content !== state.content) {
    //   return {
    //     content: props.details.content,
    //     content_loading: props.details.content_loading,
    //   }
    // }
    return null;

  }

  handleLoadContent = (catid, id) => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const req = this.props.getNewsDetails(catid, id).then((data) => {
      this.setState({
        content: data,
        slug: id
      })
    });
  }

  render() {

    const { content, content_loading } = this.state;
    // const details = this.props.details;
    console.log("this.state", this.state);

    const tags = this.props.tags;
    return (
      <Fragment>

        {content.length ? <section>

          <div className="container">
            <div className="tag-list">
              <div className="tag-title">
                <h3>Tags</h3>
              </div>
              <ul>
                {tags.map((row, key) => {
                  return (
                    <li key={key}>
                      <Link to={{ pathname: `/tag/${row.slug}` }}>{row.title}</Link>
                    </li>
                  )
                })}

              </ul>

            </div>
            <div className="related-tag-title">
              <h1>Related News</h1>
            </div>
            <div className="tag-related-wrap">
              <div className="row">

                {content.length ? <Fragment>
                  {content.map((row, key) => {
                    var catid = row.categories ? row.categories[0]['id'] : '0';
                    return (
                      <Fragment key={key}>
                        <div className="col-md-3">
                          <div className="our-latest-news-single most-popular-single">
                            <img src={`${row.image ? row.image.details_image : ''}`} />
                            <div className="our-latest-news-content">

                              <h3>
                                {row.title.length > 59 &&
                                  <Link to={`/news/${catid}/${row.id}/${row.slug}`} onClick={() => this.handleLoadContent(row.categories[0]['id'], row.id)}>{row.title.substring(0, 56)}...</Link>
                                }
                                {row.title.length <= 59 &&
                                  <Link to={`/news/${row.categories[0]['id']}/${row.id}/${row.slug}`} onClick={() => this.handleLoadContent(row.categories[0]['id'], row.id)}>{row.title}</Link>
                                }
                              </h3>
                              {row.short_description.length > 107 && <p>
                                {row.short_description.substring(0, 104)}... </p>
                              }
                              {row.short_description.length <= 107 && <p>
                                {row.short_description} </p>
                              }
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    )
                  })}

                </Fragment> : ''}



              </div>
            </div>
          </div>

        </section> : ''}
      </Fragment>

    );
  }
}


const mapStateToProps = (state) => ({
  setting: state.utils.setting,
  details: state.pubcontent.details,
})

const mapDispatchToProps = (dispatch) => ({
  getRelatedNews: (requestData) => dispatch(getRelatedNews(requestData)),
  getNewsDetails: (catid, slug) => dispatch(getNewsDetails(catid, slug)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TagNews));